import React, { Dispatch } from 'react';
import {
    SettingsModal,
    MiniEpg,
    DetailModal,
    SubtitlesModal,
    AudioModal,
    LanguageModal,
    RecordingOptionsModal,
    BingeWatchingModal,
    useConfirmationModal
} from 'LocalGluons';
import type { NextItemData, PlayerData } from 'Types';
import { PlayerManager } from '@24i/react-native-player';
// eslint-disable-next-line import/no-extraneous-dependencies
import { IAudioTrack, ITextTrack } from '@24i/player-base';
import { AdSkipPolicy } from 'LocalGluons/components/PlayerContainer/hooks/useAdvertisements';
import { Platform } from 'react-native';
import defaultStyles from './style';
import LowLatencyModal from '../LowLatencyModal';

const ChromecastModal = Platform.select({
    android: () => require('../Casting/ChromecastModal/ChromecastModal.android').default,
    default: () => <></>,
})();


// eslint-disable-next-line no-shadow
export enum playerModalsEnum {
    settings = 'settings',
    miniEpg = 'miniEpg',
    detail = 'detail',
    subtitles = 'subtitles',
    audiotracks = 'audiotracks',
    language = 'language',
    recording = 'recording',
    bingeWatching = 'bingeWatching',
    lowLatency = 'lowLatency',
    chromecast = 'chromecast'
}

interface PlayerModalProps {
    type: playerModalsEnum | null;
    visible: boolean;
    key: string;
    item: PlayerData['item'];
    currentItem?: PlayerData['item'];
    liveItem?: PlayerData['item'];
    onSubtitlesChanged?: () => void;
    onAudioChanged?: () => void;
    onVideoQualityChanged: (profile) => void;
    onClose: () => void;
    onBack: () => void;
    refreshDetailItem: () => void;
    onNavigate: () => void;
    onItemChange: (item: PlayerData['item']) => void;
    playerInstance: PlayerManager;
    textTracks: ITextTrack[];
    audioTracks: IAudioTrack[];
    selectedAudioTrack: IAudioTrack | null;
    selectedTextTrack: ITextTrack | null;
    nextBingeItem: PlayerData['item'] | null | undefined;
    setModalType: (type: playerModalsEnum | null) => void;
    setSelectedTextTrack: Dispatch<ITextTrack>;
    setSelectedAudioTrack: Dispatch<IAudioTrack>;
    setAudioTracks: Dispatch<IAudioTrack[]>;
    setLiveLoading: Dispatch<React.SetStateAction<boolean>>;
    modalDisplay: 'none' | 'flex';
    changeItem: (newItem: PlayerData['item']) => void;
    setNewCurrentItem: (newCurrentItem: PlayerData['item'], setAlsoAsLiveItem: boolean, rewind: boolean) => void;
    adSkipPolicy: AdSkipPolicy | null;
    isLiveVOD: boolean;
    onNextPress?: () => void;
    switchFromLowLatency: () => void;
    continueWatchingChannel?: any;
}

const PlayerModal = ({
    type,
    visible,
    item,
    currentItem,
    liveItem,
    onVideoQualityChanged,
    onClose,
    onBack,
    refreshDetailItem,
    onNavigate,
    onItemChange,
    playerInstance,
    textTracks,
    audioTracks,
    selectedAudioTrack,
    selectedTextTrack,
    nextBingeItem,
    setModalType,
    setSelectedTextTrack,
    setSelectedAudioTrack,
    setLiveLoading,
    modalDisplay,
    changeItem,
    setNewCurrentItem,
    adSkipPolicy,
    isLiveVOD,
    onNextPress,
    switchFromLowLatency,
    continueWatchingChannel
}: PlayerModalProps): React.ReactElement | null => {
    const { setModalContent } = useConfirmationModal();
    const playerModals = Object.freeze({
        [playerModalsEnum.settings]: SettingsModal,
        [playerModalsEnum.miniEpg]: MiniEpg,
        [playerModalsEnum.detail]: DetailModal,
        [playerModalsEnum.subtitles]: SubtitlesModal,
        [playerModalsEnum.audiotracks]: AudioModal,
        [playerModalsEnum.language]: LanguageModal,
        [playerModalsEnum.recording]: RecordingOptionsModal,
        [playerModalsEnum.bingeWatching]: BingeWatchingModal,
        [playerModalsEnum.lowLatency]: LowLatencyModal,
        [playerModalsEnum.chromecast]: ChromecastModal

    });
    if (type) {
        const Modal = playerModals[type];
        return (
            <Modal
                hidden={!visible}
                style={!visible ? defaultStyles.displayNone : defaultStyles.display}
                key={type}
                type={type}
                visible={visible}
                item={item}
                currentItem={currentItem}
                liveItem={liveItem}
                onVideoQualityChanged={onVideoQualityChanged}
                onClose={onClose}
                onBack={onBack}
                refreshDetailItem={refreshDetailItem}
                onNavigate={onNavigate}
                onItemChange={onItemChange}
                playerInstance={playerInstance}
                textTracks={textTracks}
                audioTracks={audioTracks}
                selectedAudioTrack={selectedAudioTrack}
                selectedTextTrack={selectedTextTrack}
                nextBingeItem={nextBingeItem}
                setModalType={setModalType}
                setSelectedTextTrack={setSelectedTextTrack}
                setSelectedAudioTrack={setSelectedAudioTrack}
                setModalContent={setModalContent}
                setLiveLoading={setLiveLoading}
                modalDisplay={modalDisplay}
                changeItem={changeItem}
                setNewCurrentItem={setNewCurrentItem}
                adSkipPolicy={adSkipPolicy}
                isLiveVOD={isLiveVOD}
                onNextPress={onNextPress}
                switchFromLowLatency={switchFromLowLatency}
                continueWatchingChannel={continueWatchingChannel}
            />
        );
    }

    return null;
};

export default PlayerModal;
